import React, { ReactNode } from 'react';

interface IProps {
	children: ReactNode;
}

export default function ProtectedRoute({ children }: IProps) {
	return <>{children}</>;
}
